import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  warning: {
    marginLeft: 'auto',
    color: theme.palette.error.main,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '24px',
  },
  container: {
    minWidth: '100%',
    margin: 0,
  },
  cancelButton: {
    marginRight: '2rem',
  },
  paperHeader: {
    padding: '2rem 3rem 1rem 3rem',
  },
  ruleDescription: { marginBottom: '1rem' },
  ruleDetails: { fontSize: '1rem', marginBottom: '0.5rem' },
  tabContent: {
    padding: '2rem 1rem',
  },
  rulesTitle: {
    fontSize: '1rem',
    fontWeight: 900,
    background: theme.palette.common.greyLight,
    width: '100%',
    padding: '1.125rem 1.5rem',
    marginBottom: '2rem',
  },
  ruleContainer: {
    marginBottom: '2rem',
  },
  input: {
    // Height fix to match Material Select
    height: 31,
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  paymentSelect: {
    marginBottom: '2rem',
    maxWidth: '17.5rem',
  },
  stepperClass: {
    padding: '0 6rem',
  },
}));

export { useStyles };
